import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Chakra from './Chakra';
import IndependenceBanner from './IndependenceBanner';
import { TRICOLOR_THEME_ENABLED } from '../themeConfig';
import './Header.css';

const navLinks = [
  { label: 'Narsimha', to: '/narsimha' },
  { label: 'Defence', to: '/defence' },
  { label: 'Research', to: '/research' },
  { label: 'Investor', to: '/investor' },
  { label: 'About Us', to: '/about' },
  { label: 'Blog', to: '/blog' },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <IndependenceBanner />
      <div className="tricolor-strip" aria-hidden="true" />
      <header className="header">
        <div className="header__inner">
          <Link to="/" className="header__logo">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Acriolis" className="header__logo-img" />
            <span className="header__logo-text">ACRIOLIS</span>
            {TRICOLOR_THEME_ENABLED && (
              <Chakra size={22} color="#000080" className="header__chakra" />
            )}
          </Link>

          <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="header__nav-link"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="header__actions">
            <Link to="/contact" className="header__cta">
              Contact Us
              <svg className="header__cta-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M4 12h15M13 6l6 6-6 6" />
              </svg>
            </Link>
            <button
              className="header__hamburger"
              onClick={() => setMenuOpen((o) => !o)}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
